/**
 * Prime Slideshow Controller
 * Refactored for performance, memory management, and modern ESM patterns.
 */
function initPrimeSlideshows(context) {
  const slideshows = context.querySelectorAll('.prime-slider');

  slideshows.forEach(slideshow => {
    const wrapper = slideshow.querySelector('.slides-wrapper');
    const slides = slideshow.querySelectorAll('.slide');
    const prevBtn = slideshow.querySelector('.prime-nav-btn.prev');
    const nextBtn = slideshow.querySelector('.prime-nav-btn.next');

    if (!wrapper || slides.length === 0) return;

    let currentIdx = 0;
    let timer = null;
    const intervalTime = parseInt(slideshow.dataset.interval, 10) * 1000 || 5000;

    // Clean up function to prevent event listener stacking
    const stopVideos = () => {
      slideshow.querySelectorAll('video').forEach(v => {
        v.pause();
        v.onended = null; // Clear previous ended handlers
      });
    };

    function updateGallery() {
      // Hardware accelerated transform
      wrapper.style.transform = `translateX(-${currentIdx * 100}%)`;
      
      // Reset state
      clearInterval(timer);
      stopVideos();

      const activeSlide = slides[currentIdx];
      
      if (activeSlide.classList.contains('slide-video')) {
        handleVideoSlide(activeSlide);
      } else {
        timer = setInterval(moveNext, intervalTime);
      }
    }

    function handleVideoSlide(slide) {
      const isMobile = window.innerWidth <= 767;
      const video = slide.querySelector(
        isMobile ? '.mobile-only video' : '.desktop-only video'
      );

      if (video) {
        video.currentTime = 0;
        video.play().catch(() => {
          // Fallback if browser blocks autoplay
          timer = setInterval(moveNext, intervalTime);
        });
        
        video.onended = moveNext; 
      } else {
        // Fallback for missing video source
        timer = setInterval(moveNext, intervalTime);
      }
    }

    function moveNext() {
      currentIdx = (currentIdx + 1) % slides.length;
      updateGallery();
    }

    function movePrev() {
      currentIdx = (currentIdx - 1 + slides.length) % slides.length;
      updateGallery();
    }

    // Event Listeners - UI
    if (prevBtn) prevBtn.addEventListener('click', movePrev);
    if (nextBtn) nextBtn.addEventListener('click', moveNext);

    // Touch Handling (Passive for performance)
    let touchStartX = 0;
    wrapper.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    wrapper.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? moveNext() : movePrev();
      }
    }, { passive: true });

    // Initialize first state
    updateGallery();
  });
}

// Execution Hooks
document.addEventListener('DOMContentLoaded', () => initPrimeSlideshows(document));

// Shopify Theme Editor compatibility
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => initPrimeSlideshows(e.target));
}